import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Basic404Component } from './extrapages/basic404/basic404.component';
import { BusinesslayoutComponent } from './layouts/businesslayout/businesslayout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'business-portal',
    pathMatch: 'full',
  },
  {
    path: 'business-portal',
    component: BusinesslayoutComponent,
    title: 'Nirlat - Business Portal',
    loadChildren: () => import('./business-portal/business-portal.module').then((m) => m.BusinessPortalModule),
  },
  { path: '**', component: Basic404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
